import { Text } from "@alpacahq/ui/old";

interface FeatureItemProps {
  title: string;
  description: string;
}

export const FeatureItem = ({ title, description }: FeatureItemProps) => (
  <section className="flex w-full max-w-[640px] flex-col items-start gap-2">
    <h2 className="m-0 p-0 text-left font-medium text-xl">{title}</h2>
    <Text className="text-left text-base">{description}</Text>
  </section>
);
